// @ts-nocheck
import getImageSize from "@toolkit/Framework/Common/Utilities/getImageSize";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const design: Styleguide["design"] = {
    /* Store Custom Code - Start */
    accordion: {
        padding: {
            horizontal: pxToRemArray([20]),
            vertical: pxToRemArray([20]),
        },
        spacing: pxToRemArray([2]),
    },
    /* Store Custom Code - End */
    product: {
        image: {
            small: getImageSize(210),
            medium: getImageSize(768),
            large: getImageSize(1200),
        },
    },
    category: {
        image: {
            small: getImageSize(768),
        },
    },
    /* Store Custom Code - Start */
    menu: {
        panel: {
            rowWrapperPadding: pxToRem(0, 0),
        },
        mainNavigation: {
            megaMenuFullWidth: false,
        },
    },
    typography: {
        fontFamily: {
            title: `'Cencora', sans-serif, 'Arial'`,
            base: `'Cencora', sans-serif, 'Arial'`,
        },
        lineHeight: {
            smaller: 1,
            small: 1.25,
            semi: 1.5,
            base: 1.75,
            large: 2.5,
            larger: 3,
            largest: 3.75,
        },
    },
    /* Store Custom Code - End */
};

export default design;
